import type { FaireProductEntity } from "../../entity_types/product";

export const p_vpwb24kxq2: FaireProductEntity = {
  token: "p_vpwb24kxq2",
  type: "product",
  name: "Blood Pressure  - Loose Leaf Herbal Tea",
  brandToken: "b_cev7opt9ab",
  brandName: "Nature's Inventory",
  imageUrl:
    "https://cdn.faire.com/fastly/7453e437eac86bbf5d0693d4bcb5b64acac01b87a1ad7275b9f494968f0a7e11.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.06,
  description:
    " * Organic and Wild Crafted Herbs \n * Naturally Caffeine Free \n * Promotes Healthy Blood Pressure Levels \n * Loose leaf tea provides 40-60 servings \n\nWhen you drink this tea, it will be hard to believe that something that tastes so good can be so good for you!  Hawthorn Berries, Yarrow, Lemongrass, and Hibiscus Flowers are all well known for their ability to lower your blood pressure with daily use.  We think you’ll agree, this is the best way to take “your medicine”. \n ",
  tags: [],
  msrpDollars: 22.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:58.681Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
